import React, { Component } from "react";
import * as Image from "../../../../assets/js/image";

export default class ActionRenderer extends Component {
  constructor(props) {
    super(props);
  }

  redirect() {
    window.location = "/vob";
  }

  render() {
    return (
      <p onClick={() => this.redirect()}>
        <Image.Action style="w-20" altText="action-icon" id="action" />
      </p>
    );
  }
}
